import { Outlet } from "react-router-dom";
import Header from "./../../components/v6/Header";

const FullPage = () => {
  return (
    <>
      <Header />
      <Outlet />
    </>
  );
};

export default FullPage;
